import { Button } from "@/components/ui/button";
import { Loader2, CreditCard } from "lucide-react";
import { useApp } from "@/contexts/AppContext";

interface StripeTerminalPaymentProps {
  paymentId: string;
  amount: number;
  currency: string;
  onPaymentIntentCreated?: (paymentIntentId: string) => void;
  onPaymentSuccess: (paymentIntentId: string) => void;
}

function formatAmount({ amount }: { amount: number; currency: string }) {
  return `$${(amount / 100).toFixed(2)}`;
}

export function StripeTerminalPayment({
  paymentId,
  amount,
  currency,
  onPaymentIntentCreated,
  onPaymentSuccess,
}: StripeTerminalPaymentProps) {
  const { isProcessing, collectPayment } = useApp();

  const handleCharge = async () => {
    const paymentIntentId = await collectPayment({
      paymentId,
      onPaymentIntentCreated,
    });
    if (paymentIntentId) {
      onPaymentSuccess(paymentIntentId);
    }
  };

  return (
    <Button onClick={handleCharge} disabled={isProcessing} className="w-full" size="lg">
      {isProcessing ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Processing...
        </>
      ) : (
        <>
          <CreditCard className="mr-2 h-4 w-4" />
          Charge {formatAmount({ amount, currency })}
        </>
      )}
    </Button>
  );
}
